// extracted by extract-css-chunks-webpack-plugin
module.exports = {"authorContainer":"_1Ub7bb"};